import type { ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType } from './chatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfoAllOfTwo = {
  content?: string;
  type?: ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType;
};
